import React, { useState } from 'react';
import { Navbar, Container, Nav, Dropdown, Form, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/authSlice';
import {
  Search,
  BellFill,
  PersonCircle,
  BoxArrowRight,
  GearFill,
  PersonFill,
  List,
} from 'react-bootstrap-icons';
import { getInitials } from '../utils/helpers';
import { toast } from 'react-toastify';
import '../styles/Header.css';

const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [searchQuery, setSearchQuery] = useState('');

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();
      toast.success('Logged out successfully');
      navigate('/login');
    } catch (error) {
      toast.error('Logout failed');
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/leads?search=${searchQuery}`);
    }
  };

  return (
    <Navbar bg="white" className="header-navbar shadow-sm px-0">
      <Container fluid className="px-3">

        {/* Left - Toggle + Brand */}
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-link sidebar-toggle p-2 d-lg-none"
            onClick={toggleSidebar}
          >
            <List size={22} color="#4a5568" />
          </button>
          <span className="fw-bold text-primary fs-5 d-none d-sm-inline">
            Manager Panel
          </span>
        </div>

        {/* Center - Search */}
        <Form
          onSubmit={handleSearch}
          className="search-form d-none d-md-block"
        >
          <InputGroup>
            <InputGroup.Text className="bg-white border-end-0">
              <Search size={15} color="#a0aec0" />
            </InputGroup.Text>
            <Form.Control
              type="search"
              placeholder="Search leads, projects..."
              className="border-start-0 ps-0"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ minWidth: '260px' }}
            />
          </InputGroup>
        </Form>

        {/* Right - Notifications + User */}
        <Nav className="align-items-center gap-2">

          {/* Notification Bell */}
          <Dropdown align="end">
            <Dropdown.Toggle
              as="button"
              className="btn btn-link notification-toggle position-relative p-2"
            >
              <BellFill size={18} color="#4a5568" />
              <span className="notification-badge">3</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="notification-menu shadow">
              <Dropdown.Header className="fw-bold text-dark">
                Notifications
              </Dropdown.Header>
              <Dropdown.Divider />
              {[
                { title: 'New lead assigned to you', time: '2 minutes ago' },
                { title: 'Project Alpha updated', time: '1 hour ago' },
                { title: 'Follow-up reminder: Acme Corp', time: '3 hours ago' },
              ].map((notif, i) => (
                <Dropdown.Item key={i} className="py-2">
                  <div className="notification-dot"></div>
                  <div className="notification-text">
                    <div className="fw-semibold small">{notif.title}</div>
                    <small className="text-muted">{notif.time}</small>
                  </div>
                </Dropdown.Item>
              ))}
              <Dropdown.Divider />
              <Dropdown.Item className="text-center text-primary small fw-semibold py-2">
                View All Notifications
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* User Dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle
              as="button"
              className="btn btn-link user-dropdown p-1"
            >
              <div className="d-flex align-items-center gap-2">
                <div className="user-avatar">
                  {user?.full_name
                    ? getInitials(user.full_name)
                    : <PersonCircle size={20} />}
                </div>
                <div className="d-none d-lg-block text-start">
                  <div className="user-name">{user?.full_name || 'User'}</div>
                  <div className="user-role">{user?.role || 'Manager'}</div>
                </div>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="shadow" style={{ minWidth: '200px' }}>
              <div className="px-3 py-2 border-bottom">
                <div className="fw-semibold small">{user?.full_name}</div>
                <small className="text-muted">{user?.email}</small>
              </div>
              <Dropdown.Item
                className="py-2"
                onClick={() => navigate('/profile')}
              >
                <PersonFill className="me-2 text-muted" size={15} />
                My Profile
              </Dropdown.Item>
              <Dropdown.Item
                className="py-2"
                onClick={() => navigate('/settings')}
              >
                <GearFill className="me-2 text-muted" size={15} />
                Settings
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                className="py-2 text-danger"
                onClick={handleLogout}
              >
                <BoxArrowRight className="me-2" size={15} />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

        </Nav>
      </Container>
    </Navbar>
  );
};

export default Header;